import { useParams, Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import NotFound from '@/pages/NotFound';

export default function ArticleDetailPage() {
  const { id } = useParams<{ id: string }>();
  const article = articles.find((a) => a.id === Number(id));

  if (!article) {
    return <NotFound />;
  }

  return (
    <main className="pt-16">
      <article>
        <section className="py-10 md:py-14 bg-background-50 border-b border-background-200">
          <div className="w-full px-4 md:px-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <Link to="/articles" className="hover:text-primary-500 transition-colors cursor-pointer">文章资讯</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-900">{article.title.slice(0, 15)}...</span>
            </nav>

            <div className="max-w-3xl">
              <div className="flex items-center gap-2 mb-4">
                <span className="px-2.5 py-1 bg-accent-100/80 text-accent-900 text-xs font-medium rounded-md">
                  {article.category}
                </span>
                <span className="text-xs text-foreground-500">{article.publishedAt}</span>
                <span className="text-xs text-foreground-500">· {article.readTime}</span>
              </div>
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3 leading-tight">
                {article.title}
              </h1>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                {article.excerpt}
              </p>
              <div className="flex flex-wrap items-center gap-2 mt-4">
                {article.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-2.5 py-1 bg-background-100 text-foreground-600 text-xs rounded-md"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="relative rounded-lg overflow-hidden mb-10 h-64 md:h-96">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div
                className="prose prose-sm md:prose-base max-w-none text-foreground-800 leading-relaxed
                  prose-headings:font-heading prose-headings:text-foreground-900 prose-headings:font-semibold
                  prose-h2:text-xl prose-h2:md:text-2xl prose-h2:mt-8 prose-h2:mb-4
                  prose-p:my-4 prose-p:leading-relaxed
                  prose-ul:my-4 prose-li:my-1
                  prose-strong:text-foreground-900"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />

              <div className="mt-12 pt-8 border-t border-background-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <Link
                  to="/articles"
                  className="flex items-center gap-2 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-line"></i>
                  返回文章列表
                </Link>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-foreground-500">分享至：</span>
                  <button className="w-8 h-8 flex items-center justify-center rounded-md bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors cursor-pointer" aria-label="分享到微信">
                    <i className="ri-wechat-line text-sm"></i>
                  </button>
                  <button className="w-8 h-8 flex items-center justify-center rounded-md bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors cursor-pointer" aria-label="分享到微博">
                    <i className="ri-weibo-line text-sm"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </article>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: article.title,
            description: article.excerpt,
            datePublished: article.publishedAt,
            author: { '@type': 'Organization', name: '比基尼护士' },
            publisher: { '@type': 'Organization', name: '比基尼护士' },
            image: article.coverImage,
          }),
        }}
      />
    </main>
  );
}